import APIClient from '@/shared/http/clients/api'

const resourceName = 'anotacoes-negativas'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}`, config)

/**
 * @name NegativeAnnotationsRepository
 * @description Anotações negativas
 * @type { Respository }
 */
const NegativeAnnotationsRepository = {
  Search
}

export default NegativeAnnotationsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/negativeannotations.js